// static map image from web tiles (CORS-enabled sources) with numbered pins and view-direction wedges
const SRC = {
  osm: { url: (z, x, y) => `https://tile.openstreetmap.org/${z}/${x}/${y}.png`, max: 19, attr: '© OpenStreetMap' },
  sat: { url: (z, x, y) => `https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/${z}/${y}/${x}`, max: 19, attr: '© Esri World Imagery' },
};
const px = (lat, lon, z) => { const n = 256 * 2 ** z, s = Math.sin((lat * Math.PI) / 180); return [((lon + 180) / 360) * n, (0.5 - Math.log((1 + s) / (1 - s)) / (4 * Math.PI)) * n]; };
const load = (u) => new Promise((res) => { const i = new Image(); i.crossOrigin = 'anonymous'; i.onload = () => res(i); i.onerror = () => res(null); i.src = u; });

function fitZoom(pts, w, h, zmax) {
  for (let z = zmax; z > 2; z--) {
    const P = pts.map((p) => px(p.lat, p.lon, z)), xs = P.map((p) => p[0]), ys = P.map((p) => p[1]);
    if (Math.max(...xs) - Math.min(...xs) < w * 0.7 && Math.max(...ys) - Math.min(...ys) < h * 0.7) return z;
  }
  return 3;
}

export async function mapShot({ pins = [], src = 'osm', w = 1200, h = 800, zmax = 18, center = null }) {
  const S = SRC[src], pts = pins.length ? pins : [center];
  const z = Math.min(S.max, fitZoom(pts, w, h, zmax));
  const P = pts.map((p) => px(p.lat, p.lon, z)), cx = center ? px(center.lat, center.lon, z) : [(Math.min(...P.map((p) => p[0])) + Math.max(...P.map((p) => p[0]))) / 2, (Math.min(...P.map((p) => p[1])) + Math.max(...P.map((p) => p[1]))) / 2];
  const x0 = cx[0] - w / 2, y0 = cx[1] - h / 2;
  const c = document.createElement('canvas'); c.width = w; c.height = h;
  const g = c.getContext('2d'); g.fillStyle = '#e5e7eb'; g.fillRect(0, 0, w, h);
  const jobs = [];
  for (let tx = Math.floor(x0 / 256); tx <= Math.floor((x0 + w) / 256); tx++) for (let ty = Math.floor(y0 / 256); ty <= Math.floor((y0 + h) / 256); ty++) {
    const n = 2 ** z; if (ty < 0 || ty >= n) continue;
    jobs.push(load(S.url(z, ((tx % n) + n) % n, ty)).then((im) => im && g.drawImage(im, tx * 256 - x0, ty * 256 - y0)));
  }
  await Promise.all(jobs);
  pins.forEach((p) => {
    const [x, y] = px(p.lat, p.lon, z).map((v, i) => v - (i ? y0 : x0)), col = p.color || '#dc2626';
    if (p.dir != null) {
      const a = ((p.dir - 90) * Math.PI) / 180, r = 46;
      g.fillStyle = 'rgba(250,204,21,0.55)'; g.strokeStyle = '#a16207'; g.lineWidth = 2;
      g.beginPath(); g.moveTo(x, y); g.arc(x, y, r, a - 0.4, a + 0.4); g.closePath(); g.fill(); g.stroke();
    }
    g.fillStyle = col; g.strokeStyle = '#fff'; g.lineWidth = 3;
    g.beginPath(); g.arc(x, y, 14, 0, Math.PI * 2); g.fill(); g.stroke();
    g.fillStyle = '#fff'; g.font = 'bold 15px Arial'; g.textAlign = 'center'; g.textBaseline = 'middle'; g.fillText(String(p.label ?? ''), x, y + 1);
  });
  g.font = '12px Arial'; g.textAlign = 'right'; g.textBaseline = 'bottom';
  const tw = g.measureText(S.attr).width; g.fillStyle = 'rgba(255,255,255,0.8)'; g.fillRect(w - tw - 10, h - 18, tw + 10, 18); g.fillStyle = '#111'; g.fillText(S.attr, w - 5, h - 3);
  try { return c.toDataURL('image/jpeg', 0.85); } catch { return null; }
}
